import { View } from "ui/atoms/view";
import { Text } from "react-native";
import { QuestionModel } from "app/services/api/types/forms/models/QuestionModel";
import { QuestionTypeDescriptionMapping } from "app/services/api/types/forms/enums/QuestionTypeEnum";

interface Props {
  question: QuestionModel;
}
const QuestionDetailAtom = ({ question }: Props) => {
  if (!question) {
    return null;
  }
  return (
    <View className="gap-2 flex-row justify-center items-center">
      <View className="flex-1 flex-row items-center">
        <Text className="font-semibold">{question.content}</Text>
      </View>
      <View>
        <Text className="text-xs font-semibold uppercase text-gray-800 rounded bg-gray-200 px-2 py-1">
          {QuestionTypeDescriptionMapping[question.type]?.short}
        </Text>
      </View>
    </View>
  );
};

export default QuestionDetailAtom;
